<template>
    <form >
        <div>
            <div>
                <ui-input
                    v-model="cepComputed"
                    mask="#####-###"
                    type="text"
                    :color-label="cepMessage == 'CEP:' ? '#4a586c' : 'red'"
                    :label="cepMessage"
                    size="md2" />
            </div>
        </div>
        <div class="primary-item">
            <ui-input
                v-model="dataModel.address"
                type="text"
                label="Endereço:"
                size="md2" />
        </div>
        <div>
            <div>
                <ui-input
                    v-model="dataModel.last_name"
                    type="text"
                    label="Cidade:"
                    size="md2" />
            </div>
            <div>
                <ui-input
                    v-model="dataModel.uf"
                    type="text"
                    label="Estado:"
                    size="md2" />
            </div>
        </div>
    </form>
</template>

<script>
import { uiInput }   from '@/components/ui/form'
import { offline }   from '@/services/axios'
export default {
    name: 'ui-user-address',
    components: {
        uiInput
    },
    props: {
        userModel: {
            type: Object,
            default: () => {}
        },
    },

    data() {
        return {
            dataModel: this.userModel,
            cepMessage: 'CEP:'
        }
    },

    computed: {
        cepComputed: {
            get() {
                return this.dataModel.cep
            },
            
            async set(value) {
                if (value.length < 9) {
                    this.cepMessage = 'CEP:'
                } else {
                    await offline.cep(value).then((res) => {
                        if (res.data.localidade) {
                            var address = res.data
                            this.dataModel.cep = address.cep
                            this.dataModel.last_name = address.localidade
                            this.dataModel.uf = address.uf
                            this.dataModel.address = address.logradouro
                            this.cepMessage = 'CEP:'
                            
                        } else {
                            this.cepMessage = 'CEP Inválido'
                        }
                    })
                } 
            }
        }
    }
}
</script>

<style lang='stylus' scoped>
    @import '../styles.styl'
</style>